import { ChartBar, LineChart, PieChart, Database, Gauge, Users } from "lucide-react";

export const CapabilitiesSection = () => {
  const capabilities = [
    {
      icon: <ChartBar className="h-12 w-12 text-blue-600" />,
      title: "Interactive Dashboards",
      description: "Create custom dashboards that visualize your key metrics in real-time."
    },
    {
      icon: <LineChart className="h-12 w-12 text-blue-600" />,
      title: "Advanced Analytics",
      description: "Leverage machine learning for predictive insights and trend analysis."
    },
    {
      icon: <PieChart className="h-12 w-12 text-blue-600" />,
      title: "Data Visualization",
      description: "Transform complex data into clear, actionable visualizations."
    },
    {
      icon: <Database className="h-12 w-12 text-blue-600" />,
      title: "Data Integration",
      description: "Connect and unify data from multiple sources seamlessly."
    },
    {
      icon: <Gauge className="h-12 w-12 text-blue-600" />,
      title: "Performance Metrics",
      description: "Track and analyze KPIs to measure business performance."
    },
    {
      icon: <Users className="h-12 w-12 text-blue-600" />,
      title: "Collaborative Analysis",
      description: "Share insights and collaborate with team members effectively."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Comprehensive Analytics Capabilities
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Our suite of analytics tools and capabilities helps you make data-driven 
            decisions with confidence.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {capabilities.map((capability, index) => (
            <div 
              key={index}
              className="p-6 rounded-xl border border-gray-200 hover:border-blue-500 hover:shadow-lg transition-all"
            >
              <div className="mb-4">{capability.icon}</div>
              <h3 className="text-xl font-semibold mb-2 text-gray-900">
                {capability.title}
              </h3>
              <p className="text-gray-600">{capability.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};